import { ConverterOptions, ValueConverter } from '@shared/execution/types';
import { DataField } from '@shared/providers/types';

export class BypassValueConverter implements ValueConverter {
  toExcelValue(value: any, field: DataField, options: ConverterOptions) {
    return value;
  }

  toProviderValue(value: any, dataField: DataField, options: ConverterOptions) {
    return value;
  }
}
